import { Capacitor } from '@capacitor/core';

export const isNative = () => Capacitor.isNativePlatform();
export const getPlatform = () => Capacitor.getPlatform(); // 'android' | 'ios' | 'web'

const PUBLIC_APP_ORIGIN = 'https://buyfors.com';

// On native (capacitor://localhost) returns the public web origin so share links open the real site.
export const getPublicAppOrigin = () =>
  isNative() ? PUBLIC_APP_ORIGIN : window.location.origin;
